import React, { useEffect, useState } from 'react'

import { makeStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'
import { postEnrollmentsData, getSISStatus } from '../../actions/'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'

import GetAppIcon from '@material-ui/icons/GetApp'

import TextField from '@material-ui/core/TextField'
import { Grid } from '@material-ui/core'
import Icon from '@material-ui/core/Icon'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'

import {
  createUsersUpdateCsv,
  createUsersUpdateUserCount,
  createUsersUpdateFormData,
  saveBestTeachingAwardFromUploadRequest
} from '../../actions'

import { getSearchUsers } from '../../services/saga'

import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  }
}))

function createData(name, downloadLink) {
  return { name, downloadLink }
}

const rows = [
  createData('Users Csv', 'users-template.csv'),
  createData('Enrollment Csv ', 'enrollments.csv'),
  // createData('Group Csv ', 'groups.csv'),
  createData('Delete User Csv ', 'delete-users.csv')
]

function StepOne(props) {
  const {
    data,
    updateUserCountState,
    updateCsvState,
    updateUserFormState,
    saveBestTeachingAwardFromUploadRequest
  } = props

  const classes = useStyles()

  const [createUserCount, setCreateUserCount] = React.useState([1])
  const [simulateUsers, setSimulateUsers] = React.useState(false)
  const [csvData, setCsvData] = React.useState([])

  const onClickElementCreate = () => {
    let count = createUserCount.concat(createUserCount.length + 1)

    setCreateUserCount(count)

    updateUserCountState(count)

    setUserFormData(
      userFormData.concat([
        {
          psID: '',
          email: '',
          firstName: '',
          lastName: '',

          psIDError: '',
          emailError: '',
          firstNameError: '',
          lastNameError: '',

          loadingEmailCheck: false
        }
      ])
    )
  }

  const onClickElementRemove = () => {
    userFormData.pop()

    setUserFormData(userFormData)

    let count = createUserCount.splice(0, createUserCount.length - 1)

    setCreateUserCount(count)

    updateUserCountState(count)

    buildUserCsv()
  }

  const buildUserCsv = () => {
    let csv = userFormData.map((object, i) => {
      let first_name = object.firstName
      let last_name = object.lastName

      if (first_name != '') {
        first_name = first_name
          .toLowerCase()
          .replace(/\b[a-z]/g, function (letter) {
            return letter.toUpperCase()
          })
      }

      if (last_name != '') {
        last_name = last_name.toUpperCase()
      }

      let login_id = object.email

      if (login_id != '') {
        login_id = login_id.toLowerCase()
      }

      let integration_id = object.psID
      let sortable_name = `${last_name}, ${first_name}`
      let short_name = `${first_name} ${last_name}`
      let email = login_id
      let status = 'active'

      return [
        integration_id,
        integration_id,
        login_id,
        first_name,
        last_name,
        '"' + sortable_name + '"',
        short_name,
        email,
        status
      ]
    })

    setCsvData(csv)

    updateCsvState(csv)

    console.log(csv)
  }

  const [userFormData, setUserFormData] = React.useState([
    {
      psID: '',
      email: '',
      firstName: '',
      lastName: '',
      psIDError: '',
      emailError: '',
      firstNameError: '',
      lastNameError: '',
      loadingEmailCheck: false
    }
  ])

  useEffect(() => {
    console.log(userFormData)

    updateUserFormState(userFormData)

    buildUserCsv()
  }, [userFormData])

  useEffect(() => {
    if (data.createUserCount) {
      setCreateUserCount(data.createUserCount)
    }

    if (data.userFormData.length != 0) {
      setUserFormData(data.userFormData)
    }
  }, [])

  function isNumeric(value) {
    return /^\d+$/.test(value)
  }

  function validateEmail(email) {
    var re = /^\w+([\.-]?\w+)*@insead.edu$/
    return re.test(email)
  }

  function validateNames(name) {
    var re = /^[a-zA-Z- ]+$/
    return re.test(name)
  }

  const inputOnChange = async (field, index, e) => {
    setUserFormData(
      userFormData.map((object, i) => {
        if (field === 'psID') {
          let input = e.target.value.trim()
          let inputError = ''

          if (!isNumeric(input)) {
            inputError = 'Peoplesoft ID must be digits.'
          }

          if (i === index - 1) {
            return { ...object, psID: input, psIDError: inputError }
          }

          return { ...object }
        }

        if (field === 'email') {
          let input = e.target.value.trim().toLowerCase()
          let inputError = ''

          if (!validateEmail(input)) {
            inputError =
              'Email is not valid. Please enter insead.edu email address.'
          }

          if (i === index - 1) {
            return { ...object, email: input, emailError: inputError }
          }

          return { ...object }
        }

        if (field === 'firstName') {
          let input = e.target.value
          let inputError = ''

          if (!validateNames(input)) {
            inputError = 'Special charactors and numbers not allowed.'
          }

          if (i === index - 1) {
            return { ...object, firstName: input, firstNameError: inputError }
          }

          return { ...object }
        }

        if (field === 'lastName') {
          let input = e.target.value
          let inputError = ''

          if (!validateNames(input)) {
            inputError = 'Special charactors and numbers not allowed.'
          }

          if (i === index - 1) {
            return { ...object, lastName: input, lastNameError: inputError }
          }

          return { ...object }
        }
      })
    )

    if (field === 'email') {
      let input = e.target.value.trim().toLowerCase()
      let inputError = ''

      if (validateEmail(input)) {
        setUserFormData(
          userFormData.map((object, i) => {
            if (i === index - 1) {
              return {
                ...object,
                email: input,
                emailError: inputError,
                loadingEmailCheck: true
              }
            }

            return { ...object }
          })
        )

        let checkUser = await getSearchUsers(input)

        if (checkUser.data.length !== 0) {
          if (checkUser.data[0].login_id.trim().toLowerCase() === input) {
            inputError = `The User Already exists in LMS. \n PeopleSoftID: ${checkUser.data[0].sis_user_id} `
          }
        }

        setUserFormData(
          userFormData.map((object, i) => {
            if (i === index - 1) {
              return {
                ...object,
                email: input,
                emailError: inputError,
                loadingEmailCheck: false
              }
            }

            return { ...object }
          })
        )
      }
    }
  }

  return (
    <Paper square>
      <form className={classes.root} noValidate autoComplete='off'>
        {createUserCount.map((data) => {
          let Ui = (
            <Grid key={`grid-${data - 1}`} container spacing={3}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id='outlined-name'
                  label='PeopleSoft ID'
                  onChange={(e) => inputOnChange('psID', data, e)}
                  error={userFormData[data - 1]?.psIDError.length}
                  helperText={userFormData[data - 1]?.psIDError}
                  value={userFormData[data - 1]?.psID}
                  variant='outlined'
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id='outlined-name'
                  label='Email'
                  onChange={(e) => inputOnChange('email', data, e)}
                  error={userFormData[data - 1]?.emailError.length}
                  helperText={userFormData[data - 1]?.emailError}
                  InputProps={{
                    endAdornment:
                      userFormData[data - 1]?.loadingEmailCheck === true ? (
                        <CircularProgress />
                      ) : null
                  }}
                  value={userFormData[data - 1]?.email}
                  variant='outlined'
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id='outlined-name'
                  label='First Name'
                  onChange={(e) => inputOnChange('firstName', data, e)}
                  error={userFormData[data - 1]?.firstNameError.length}
                  helperText={userFormData[data - 1]?.firstNameError}
                  value={userFormData[data - 1]?.firstName}
                  variant='outlined'
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id='outlined-name'
                  label='Last Name'
                  onChange={(e) => inputOnChange('lastName', data, e)}
                  error={userFormData[data - 1]?.lastNameError.length}
                  helperText={userFormData[data - 1]?.lastNameError}
                  value={userFormData[data - 1]?.lastName}
                  variant='outlined'
                />
              </Grid>

              <Grid item xs={12}>
                <Button onClick={onClickElementCreate} variant='outlined'>
                  <Icon style={{ fontSize: 20 }} color='primary'>
                    add
                  </Icon>
                </Button>

                {data === createUserCount.length &&
                createUserCount.length !== 1 ? (
                  <Button onClick={onClickElementRemove} variant='outlined'>
                    <Icon style={{ fontSize: 20 }} color='primary'>
                      remove
                    </Icon>
                  </Button>
                ) : null}
              </Grid>
            </Grid>
          )

          return Ui
        })}
      </form>

      <FormControlLabel
        style={{ marginTop: 20, marginLeft: 10 }}
        control={
          <Switch
            checked={simulateUsers}
            onChange={(e) => setSimulateUsers(e.target.checked)}
            name='checkedCsv'
            color='primary'
          />
        }
        label='Simulate Users'
      />

      <TableContainer hidden={!simulateUsers} component={Paper}>
        <Table className={classes.table} aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell>User ID</TableCell>

              <TableCell>Integration Id</TableCell>
              <TableCell align='right'>Login Id</TableCell>
              <TableCell align='right'>First Name</TableCell>
              <TableCell align='right'>Last Name</TableCell>
              <TableCell align='right'>Sortable Name</TableCell>
              <TableCell align='right'>Short Name</TableCell>
              <TableCell align='right'>Email</TableCell>
              <TableCell align='right'>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {csvData.map((row, i) => (
              <TableRow key={`tt-${i}`}>
                <TableCell align='right'>{row[0]}</TableCell>
                <TableCell align='right'>{row[1]}</TableCell>
                <TableCell align='right'>{row[2]}</TableCell>
                <TableCell align='right'>{row[3]}</TableCell>
                <TableCell align='right'>{row[4]}</TableCell>
                <TableCell align='right'>{row[5]}</TableCell>
                <TableCell align='right'>{row[6]}</TableCell>
                <TableCell align='right'>{row[7]}</TableCell>
                <TableCell align='right'>{row[8]}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}

function mapStateToProps(state) {
  return {
    data: state.CreateUsers
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateCsvState: (data) => {
    dispatch(createUsersUpdateCsv(data))
  },

  updateUserCountState: (data) => {
    dispatch(createUsersUpdateUserCount(data))
  },

  updateUserFormState: (data) => {
    dispatch(createUsersUpdateFormData(data))
  },
  saveBestTeachingAwardFromUploadRequest: (data) => {
    dispatch(saveBestTeachingAwardFromUploadRequest(data))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(StepOne)
